module.exports = __webpack_public_path__ + "static/media/Lisa.5ec4657f.jpg";